import { map, switchMap, take } from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { getToken, State } from '@core/ngrx';
import { appConfig } from '@config/app.config';
import { NousToken } from '@app/shared/models/nous-token.model';

@Injectable()
export class ConfigInterceptor implements HttpInterceptor {
  private router = inject(Router);
  private appState$ = inject<Store<State>>(Store);


  readonly token$: Observable<NousToken> = this.appState$.pipe(select(getToken));

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.startsWith('./assets') || request.url.startsWith('/assets')) {
      return next.handle(request);
    }
    return this.token$.pipe(
      take(1),
      map(token => this.setHeaders(request, token)),
      switchMap(req => next.handle(req))
    );
  }

  setHeaders(request: HttpRequest<any>, token: NousToken): HttpRequest<any> {
    if (token) {
      request = request.clone({
        setHeaders: {
          authorization: `Bearer ${token.accessToken}`
        }
      });
    }

    if (!request.url.includes('/protocol/openid-connect')) {
      const setHeaders = {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache'
      };

      // Set nc-channel for all calls except the meta call
      if (!request.url.includes('/be/meta')) {
        setHeaders['nc-channel'] = appConfig.cms.auth.ncChannelHeader;
      }

      return request.clone({ setHeaders });
    }

    return request;
  }
}
